import { connectRatingMenu } from "instantsearch.js/es/connectors";

const customStarRating = connectRatingMenu((renderOptions, isFirstRender) => {
  const { items, refine, widgetParams } = renderOptions;

  const container = widgetParams.container;
  const root =
    typeof container === "string"
      ? document.querySelector(container)
      : container;

  if (!root) return;

  // find currently selected star count
  const selected = items.find((item) => item.isRefined);
  const selectedStars = selected ? parseInt(selected.value) : 0;

  // render stars
  root.innerHTML = starsHtml(selectedStars);

  // handle click events
  root.querySelectorAll("[data-star]").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      const clicked = parseInt(e.currentTarget.getAttribute("data-star"), 10);
      refine(clicked === selectedStars ? 0 : clicked);
    });
  });
});

const starsHtml = (selectedStars) => {
  return `
    <div class="mb-2">
      ${[1, 2, 3, 4, 5]
        .map(
          (i) => `
            <a href="#" data-star="${i}" class="text-warning"
              style="text-decoration: none; cursor: pointer; font-size: 20px">
              ${i <= selectedStars ? "★" : "☆"}
            </a>`,
        )
        .join("")}
    </div>
  `;
};

// IMPORTANT: Set "max" to 6 to support 5-star ratings.
// Algolia's ratingMenu creates one less item than the "max" value.
const customRatingWidget = () =>
  customStarRating({
    container: "#ratings-menu",
    attribute: "aggregate_ratings.overall_rating",
    max: 6,
  });

export default customRatingWidget;
